import offerFormValuesStateMachine from './offerFormValuesStateMachine';
import projectFormValuesStateMachine from './projectFormValuesStateMachine';
import productFormValuesStateMachine from './productFormValuesStateMachine';
export default function formValuesStateMachineReducer(state, action) {
    switch (action.payload.form) {
        case 'product':
            state.product = productFormValuesStateMachine(state.product, action);
            break;
        case 'project':
            state.project = projectFormValuesStateMachine(state.project, action);
            break;
        case 'offer':
            state.offer = offerFormValuesStateMachine(state.offer, action);
            break;
    }
    return state;
}
